export default "__VITE_ASSET__b85e9c60__"